export const getServerURL = () => {
  return process.env.REACT_APP_SERVER_URL
}
